import {
  Box,
  Grid,
  FormControl,
  Button,
  OutlinedInput
} from '@mui/material';
import React, { useState } from 'react';
import commonService from 'src/service/common';
import { _axios } from 'src/plugins/axios';

const ViewDocsToolbar = (props) => {
  const [corporateName, setCorporateName] = useState("ABHI");
  const [requestId, setRequestId] = useState("");
  const [policyName, setPolicyName] = useState("Policy");

  const searchDocuments = async () => {
    let payLoad = {
      requestId: requestId.replace(/\D/g, ''),
    };

    _axios
      .post('/viewDocs/getFiles', payLoad, {
        headers: {
          authtoken: commonService.getAuthToken(),
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        props.handleResponse(response.data);
      })
      .catch((error) => {
        props.handleResponse(error);
      });
  };




  return (
    <Box width={"30%"}>
      <Grid direction="column" container spacing={3} sx={{ py: '8px' }}>

        <Grid item xs={12} sm={2}>
          <FormControl size="small" fullWidth variant="outlined">
            <OutlinedInput
              id="Corporate"
              labelWidth={0}
              value={corporateName}
              onChange={(event) => setCorporateName(event.target.value)}
              placeholder="Corporate name"
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={2}>
          <FormControl size="small" fullWidth variant="outlined">
            <OutlinedInput
              id="policyName"
              labelWidth={0}
              value={policyName}
              onChange={(event) => setPolicyName(event.target.value)}
              placeholder="Policy"
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={2}>
          <FormControl size="small" fullWidth variant="outlined">
            <OutlinedInput
              id="claimNumber"
              labelWidth={0}
              value={requestId}
              onChange={(event) => setRequestId(event.target.value)}
              placeholder="TPA claim number"
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={2} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Button variant="outlined" onClick={searchDocuments}>Search</Button>
        </Grid>
      </Grid>

    </Box>
  );
};

export default ViewDocsToolbar;
